import styled from 'styled-components';
import { Button } from '../Button';

export const CounterContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const ButtonWrapper = styled(Button)`
  align-items: center;
  background-color: #f6f6f6;
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;

  &:hover {
    background-color: #f6f6f6;
  }

  &:active {
    transform: scale(0.9);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.39;
  }
`;

export const ValueDisplay = styled.span`
  font-family: ${(p) => p.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-align: center;
`;
